import API from "apiInstance";
import { toast } from "react-toastify";

export const getAllNGOAdmin = async () => {
  try {
    const response = await API({
      method: "get",
      url: "/api/ngo/all",
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const getNGOProfileAdmin = async ({ ngoId }) => {
  try {
    const response = await API({
      method: "get",
      url: `api/ngo/get-profile/${ngoId}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const deleteNGOAdmin = async ({ ngoId }) => {
  try {
    const response = await API({
      method: "delete",
      url: `api/ngo/delete/${ngoId}`,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};

export const generateNGOAdmin = async (body) => {
  try {
    const response = await API({
      method: "delete",
      url: `api/ngo/generateNGO`,
      data: body,
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
